// extracted by mini-css-extract-plugin
module.exports = {"svgWrap":"style_svg-wrap__cN_tN","svg":"style_svg__eNKan"};